import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col } from 'reactstrap';

const AttributionChartWrapper = ({ title, subtitle, children }) => (
  <Col md={12}>
    <Card>
      <CardBody>
        <div className="card__title">
          <h5 className="bold-text">{title}</h5>
          <h5 className="subhead">{subtitle}</h5>
        </div>
        <p>{children}</p>
      </CardBody>
    </Card>
  </Col>
);

AttributionChartWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

AttributionChartWrapper.defaultProps = {
  subtitle: '',
  title: 'Example Title',
};

export default AttributionChartWrapper;
